import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cancelFriendRequest } from "../../../actions/friend";
import { cancelCasualFriendNotifications } from "../../../actions/notification";

const CancelUserRequestCasual = ({
  match,
  cancelFriendRequest,
  setcancelrequestoverlay,
  cancelCasualFriendNotifications,
  profile: { user, avatar, firstname, lastname, jobtitle, location },
  User,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setcancelrequestoverlay({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to cancel your pending friend request to{" "}
            <span className="green bold">
              {firstname} {lastname}
            </span>
            ?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-green"
              onClick={() =>
                cancelFriendRequest({ user }) &&
                cancelCasualFriendNotifications(match.params.channelid) &&
                setcancelrequestoverlay({ request: false, confirm: true })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-green"
              onClick={() =>
                setcancelrequestoverlay({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CancelUserRequestCasual.propTypes = {
  auth: PropTypes.object.isRequired,
  cancelFriendRequest: PropTypes.func.isRequired,
  cancelCasualFriendNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps, {
  cancelFriendRequest,
  cancelCasualFriendNotifications,
})(CancelUserRequestCasual);
